import { Certificate, ResultStatus } from '@app/desktop/desktopSchema';
import { IWebCertificate } from './interfaces';

interface IFilter {
  validity?: string,
  issuer?: string,
  subject?: string,
  keyStores?: [string?],
  thumbPrint?: string,
  profile?: string,
}

function formatDate(date: Date) {
  return [
    date.getDate(),
    date.toLocaleString('en-US', { month: 'short' }),
    date.getFullYear()
  ].join('-');
}

export default class WebCertificate implements IWebCertificate {
  constructor(protected cert: Certificate) {}

  get serialNumber() {
    return this.cert.serialNumberH;
  }
  get thumbPrint() {
    return this.cert.thumbPrint;
  }
  get subject() {
    return {
      DN: this.cert.subject.DN,
      CN: this.cert.subject.parsedDN.CN,
      EMAILADDRESS: this.cert.subject.parsedDN.EMAILADDRESS,
    }
  }
  get issuer() {
    return {
      DN: this.cert.issuer.DN,
      CN: this.cert.issuer.parsedDN.CN,
      O: this.cert.issuer.parsedDN.O,
    }
  }

  get validity() {
    return {
      isExpired: this.cert.daysToExpire < 0,
      from: formatDate(new Date(1000 * this.cert.notBeforeTS)),
      left: this.cert.daysToExpire,
      until: formatDate(new Date(1000 * this.cert.notAfterTS)),
      total: Math.round((this.cert.notAfterTS - this.cert.notBeforeTS) / (60 * 60 * 24))
    };
  }

  get profile() {
    return {
      id: this.cert.keyStoreId,
      keyStore: this.cert.keyStoreId,
      keyStoreType: this.cert.keyStoreType,
      name: this.cert.profile && this.cert.profile.name,
      friendlyName: this.cert.profile && this.cert.profile.friendlyName,
      keyStoreFriendlyName: this.cert.profile && this.cert.profile.keyStoreFriendlyName,
      status: this.cert.profile && this.parseResultStatus(this.cert.profile.status)
    };
  }

  private parseResultStatus({ resultList, resultStatus }: ResultStatus) {
    return {
      code: (resultList[0] && resultList[0].code) || 0,
      critical: resultStatus == 2
    }
  }

  matchs(filter: IFilter = {}) {
    let match : any = true;

    match = match && (filter.keyStores === undefined || filter.keyStores.length == 0 || filter.keyStores.includes(this.profile.keyStore));

    if (filter.validity !== undefined) {
      const [bw, fw]: any = filter.validity && filter.validity.replace(/\*/g, '3000').split(',');
      match = match && bw < this.validity.left && this.validity.left < fw;
    }

    match = match && (filter.issuer === undefined || this.issuer.DN.includes(filter.issuer));
    match = match && (filter.subject === undefined || this.subject.DN.includes(filter.subject));


    match = match && (filter.thumbPrint === undefined || this.thumbPrint === filter.thumbPrint);
    match = match && (filter.profile === undefined || this.profile.name === filter.profile);

    return match;
  }
}
